import React from 'react';
import { Text, Box, Popover } from '@wix/design-system';
import { StatusWarningFilledSmall } from '@wix/wix-ui-icons-common';
import { useEssentials } from '../../contexts/essentials-context';
export function SetupIncompleteBadge() {
    const [isPopoverShown, setIsPopoverShown] = React.useState(false);
    const { t } = useEssentials();
    return (React.createElement(Popover, { showArrow: true, appendTo: "window", placement: "right", theme: "dark", shown: isPopoverShown, onMouseEnter: () => {
            setIsPopoverShown(true);
        }, onMouseLeave: () => {
            setIsPopoverShown(false);
        } },
        React.createElement(Popover.Element, null,
            React.createElement(Box, { verticalAlign: "bottom" },
                React.createElement(Box, { verticalAlign: "bottom" },
                    React.createElement(StatusWarningFilledSmall, { color: "#fdb10c" })),
                React.createElement(Box, { marginLeft: "4px" },
                    React.createElement(Text, { skin: "standard", secondary: true, weight: "thin", size: "tiny" }, t('solutionBox.solutionBottomActionBar.IncompleteSetup'))))),
        React.createElement(Popover.Content, null,
            React.createElement(Box, { padding: "12px 24px", maxWidth: "102px" },
                React.createElement(Text, { skin: "standard", light: true, weight: "thin", size: "small" }, t('solutionBox.solutionBottomActionBar.IncompleteSetupTooltip'))))));
}
//# sourceMappingURL=setup-incomplete-badge.js.map